<template>
  <div class="production_wrap">
    <div class="production_img">
      <div class="img_tit">经销商经营管理系统</div>
      <div class="img_desc">集采购、销售、库存、财务、管理于一体的数字化工具，帮助企业高效管控经销网络并提升渠道运营效率。</div>
      <!--<router-link class="img_btn" to="/demo">立即体验</router-link>-->
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center" style="width:40%;">
          <div class="production_title">产品优势及特点</div>
          <div class="production_desc">
            "柳叶云"是一款专门为医疗器械行业定制的供应链管理软件。
          </div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
    </div>
    <p></p>
    <div class="production_core_scene"></div>
    <div class="production_card">
      <ProCard :procardList="procardList" />
    </div>
    <!-- 注释掉 procardList2 相关内容
    <div class="production_card">
      <ProCard2 :procardList="procardList2" />
    </div>
    -->
    <div class="advantage_out_wrap">
      <AdvantageCard />
    </div>
  </div>
</template>

<script>
import ProCard from './ProCard.vue'
import AdvantageCard from './AdvantageCard.vue'

export default {
  data() {
    return {
      procardList: [
        {
          tit: '经销商经营管理系统'
        }
      ]
    }
  },
  components: {
    ProCard,
    AdvantageCard
  }
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;
  
  .production_img {
    width: 100%;
    height: 600PX;
    @media screen and (max-width: 768PX) {
      height: 50vw;
    }
    background: url('../../assets/img/banner1.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    
    .img_tit {
      font-size: 60PX;
      font-weight: bold;
      max-width: 1200PX;
      text-align: center;
      padding: 0 20PX;
      @media screen and (max-width: 768PX) {
        font-size: 20PX;
      }
    }
    
    .img_desc {
      font-size: 28PX;
      margin-top: 20PX;
      max-width: 1200PX;
      text-align: center;
      padding: 0 20PX;
      line-height: 1.5;
      @media screen and (max-width: 768PX) {
        font-size: 14PX;
      }
    }
    
    .img_btn {
      width: 180PX;
      height: 50PX;
      border: solid 1PX rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30PX;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      
      &:hover {
        color: #fff;
        background: orange;
      }
      
      @media screen and (max-width: 768PX) {
        width: 80PX;
        height: 30PX;
        font-size: 14PX;
      }
    }
  }
}
</style> 